"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBarProgressBar = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const Tooltip_1 = tslib_1.__importDefault(require("../tooltip/Tooltip"));
const OverlayTrigger_1 = tslib_1.__importDefault(require("../overlay/OverlayTrigger"));
const StatusBarConstants_1 = require("./StatusBarConstants");
const StatusBarProgressBar = (props) => {
    const { index, progress: { className, color, percentage = 0, tooltip, tooltipDelay = 50, tooltipPosition = StatusBarConstants_1.TOP }, useProgressDivider, } = props;
    const progressBarClasses = (0, classnames_1.default)('progress-bar', color !== null && color !== void 0 ? color : 'progress-bar-info', useProgressDivider && 'progress-divider', className);
    const progressBar = (0, jsx_runtime_1.jsx)("div", { className: progressBarClasses, style: { width: `${percentage}%` } });
    if (!tooltip) {
        return progressBar;
    }
    return ((0, jsx_runtime_1.jsx)(OverlayTrigger_1.default, Object.assign({ placement: tooltipPosition, overlay: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ id: `tooltip-${index}`, width: 'auto' }, { children: tooltip })), delay: tooltipDelay }, { children: progressBar })));
};
exports.StatusBarProgressBar = StatusBarProgressBar;
exports.default = exports.StatusBarProgressBar;
